import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Location } from '../domain/interfaces/location';
import {
  createDeleteLocationReducer,
  createFetchLocationMapImageReducer,
  createFetchLocationReducer,
  createFetchLocationsByFilterReducer,
  createFetchLocationsReducer,
  createUpsertLocationReducer,
} from './reducers';

export interface LocationsState {
  locations: Location[];

  isLoading: boolean;
  isLoaded: boolean;

  allDataLoaded: boolean;
  locationLoadedLimit: number;

  isProcessing: boolean;
  isProcessed: boolean;
  processName?: string;

  filter: {
    text: string;
    locations: Location[];

    isLoading: boolean;
    isLoaded: boolean;
    allDataLoaded: boolean;
  };

  tournamentId?: number;
}

const initialState: LocationsState = {
  locations: [],

  isLoading: false,
  isLoaded: false,

  allDataLoaded: false,
  locationLoadedLimit: 50,

  isProcessing: false,
  isProcessed: false,

  filter: {
    text: '',
    locations: [],

    isLoading: false,
    isLoaded: false,
    allDataLoaded: false,
  },

  tournamentId: undefined,
};

export const LocationsSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<{ text: string }>) => {
      state.filter.text = action.payload.text;
    },
    setTournamentId: (state, action: PayloadAction<{ tournamentId: number }>) => {
      state.tournamentId = action.payload.tournamentId;
      state.locations = [];
    },
  },
  extraReducers: (builder) => {
    createFetchLocationsReducer(builder);
    createFetchLocationsByFilterReducer(builder);
    createUpsertLocationReducer(builder);
    createDeleteLocationReducer(builder);
    createFetchLocationMapImageReducer(builder);
    createFetchLocationReducer(builder);
  },
});

export const { setFilter, setTournamentId } = LocationsSlice.actions;

export default LocationsSlice.reducer;
